import { Customized } from './customized';
import { DefaultUsage } from './default-usage';

export const stories = { Customized, DefaultUsage };
